import TUIChat from './TUIChat';
import Component from './component';
import time from './time';
import AIDesk from './aidesk';

const messages = {
  ko: {
    "取消": '취소',
    "确定": '확인',
    "发送": '보내기',
    "系统通知": '시스템 알림',
    "关闭": '닫기',
    "图片": '사진',
    "文件": '파일',
    "表情": '이모티콘',
    "视频": '동영상',
    "录制": '녹음',
    "拍照": '사진 찍기',
    AIDesk,
    TUIChat,
    Component,
    time,
  },
};

export default messages;
